import React from "react";

function AddSubAgent() {
  return <div>AddSubAgent</div>;
}

export default AddSubAgent;
